var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CheckmarkCheck") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check---checked",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-5.000000, -5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.90826785,14.3529699 L12.0618556,22.1383062 L23.0918105,5.47579541 C23.2696105,5.20679668 23.5509821,5.03434307 23.86062,5.00458942 C24.1702579,4.97483577 24.4765491,5.09081983 24.6975192,5.32150005 C25.0637725,5.72786701 25.1017667,6.35242891 24.7877547,6.80482313 L13.1329949,24.4112062 C12.88853,24.7801817 12.4886147,25 12.0618029,25 C11.6349911,25 11.2350758,24.7801817 10.990611,24.4112062 L5.21232363,15.6821087 C4.89822241,15.2296707 4.9361955,14.604998 5.30250655,14.1985635 C5.5235006,13.9678931 5.82980937,13.8519276 6.13945597,13.8817025 C6.44910257,13.9114774 6.7304742,14.083953 6.90826785,14.3529699 Z",
    id: "CheckmarkCheck",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkCheck);
export default __webpack_public_path__ + "static/media/CheckmarkCheck.148ccf636845a296c16b4c486c0d538d.svg";
export { ForwardRef as ReactComponent };